export interface AmazonProductSourceFieldOption {
  path: string;
  label: string;
}

export const AMAZON_PRODUCT_SOURCE_FIELDS: AmazonProductSourceFieldOption[] = [
  { path: 'ean', label: 'EAN' },
  { path: 'sku', label: 'Seller SKU' },
  { path: 'asin', label: 'ASIN' },
  { path: 'upc', label: 'UPC' },
  { path: 'gtin', label: 'GTIN' },
  { path: 'isbn', label: 'ISBN' },
];

/** Orders and FBA inventory include these. The other identifiers are only on the listing. */
export const AMAZON_ORDER_SOURCE_FIELDS = new Set(['sku', 'asin']);
